<template>
  <div v-bind:class="{ 'checkbox-focused': isFocused }">
    <label :aria-label="label" role="checkbox" class="pure-material-checkbox">
      <input
        type="checkbox"
        :title="label"
        v-on:keyup.enter="emitEnterKeyup"
        @click.stop
        @change="emitInput"
        @focus="emitFocus"
        @blur="emitBlur"
        :checked="value"
        :value="value"
        :indeterminate.prop="indeterminate"
      />
      <span @click.stop
        ><span v-show="showLabel" class="pl-2 v-label theme--light">{{
          label
        }}</span></span
      >
    </label>
  </div>
</template>

<script>
export default {
  name: "CheckboxCustom",
  data: () => {
    return {
      isFocused: false,
    };
  },
  props: {
    label: String,
    value: Boolean,
    indeterminate: Boolean,
    showLabel: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    emitInput(e) {
      this.isFocused = false;
      this.$emit("input", e.target.checked);
    },
    emitFocus(e) {
      this.isFocused = true;
      this.$emit("focus", e);
    },
    emitBlur(e) {
      this.isFocused = false;
      this.$emit("blur", e);
    },
    emitEnterKeyup() {
      this.$emit("enter");
    },
  },
};
</script>

<style>
.pure-material-checkbox {
  z-index: 0;
  position: relative;
  display: inline-block;
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.87);
  font-family: var(
    --pure-material-font,
    "Roboto",
    "Segoe UI",
    BlinkMacSystemFont,
    system-ui,
    -apple-system
  );
  font-size: 16px;
  line-height: 1.5;
}
.checkbox-focused {
  background: #fd0 !important;
}
/* Input */
.pure-material-checkbox > input {
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: -1;
  position: absolute;
  left: -11px;
  top: -8px;
  display: block;
  margin: 0;
  border-radius: 50%;
  width: 0px;
  height: 0px;
  background-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
  box-shadow: none;
  outline: none;
  opacity: 0;
  transform: scale(1);
  pointer-events: none;
}

/* Span */
.pure-material-checkbox > span {
  display: inline-block;
  width: 100%;
  cursor: pointer;
}

/* Box */
.pure-material-checkbox > span::before {
  content: "";
  display: inline-block;
  box-sizing: border-box;
  margin: 2px 0px 3px 0px;
  border: solid 2px; /* Safari */
  border-color: rgba(0, 0, 0, 0.4);
  border-radius: 2px;
  width: 18px;
  height: 18px;
  vertical-align: top;
  transition: border-color 0.2s, background-color 0.2s;
}

/* Checkmark */
.pure-material-checkbox > span::after {
  content: "";
  display: block;
  position: absolute;
  top: 2px;
  left: 0px;
  width: 12px;
  height: 7px;
  border: solid 2px transparent;
  border-right: none;
  border-top: none;
  transform: translate(3px, 4px) rotate(-45deg);
}

/* Checked, Indeterminate */
.pure-material-checkbox > input:checked,
.pure-material-checkbox > input:indeterminate {
  background-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
}

.pure-material-checkbox > input:checked + span::before,
.pure-material-checkbox > input:indeterminate + span::before {
  border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
  background-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
}

.pure-material-checkbox > input:checked + span::after,
.pure-material-checkbox > input:indeterminate + span::after {
  border-color: rgb(var(--pure-material-onprimary-rgb, 255, 255, 255));
}

.pure-material-checkbox > input:indeterminate + span::after {
  border-left: none;
  transform: translate(3px, 3px);
}

/* Hover, Focus */
.pure-material-checkbox:hover > input {
  opacity: 0.04;
}

.pure-material-checkbox > input:focus {
  opacity: 0.12;
}

.pure-material-checkbox:hover > input:focus {
  opacity: 0.16;
}

/* Active */
.pure-material-checkbox > input:active {
  opacity: 1;
  transform: scale(0);
  transition: transform 0s, opacity 0s;
}

.pure-material-checkbox > input:active + span::before {
  border-color: rgb(var(--pure-material-primary-rgb, 33, 150, 243));
}

.pure-material-checkbox > input:checked:active + span::before {
  border-color: transparent;
  background-color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.6);
}

/* Disabled */
.pure-material-checkbox > input:disabled {
  opacity: 0;
}

.pure-material-checkbox > input:disabled + span {
  color: rgba(var(--pure-material-onsurface-rgb, 0, 0, 0), 0.38);
  cursor: initial;
}

.pure-material-checkbox > input:disabled + span::before {
  border-color: currentColor;
}

.pure-material-checkbox > input:checked:disabled + span::before,
.pure-material-checkbox > input:indeterminate:disabled + span::before {
  border-color: transparent;
  background-color: currentColor;
}
</style>
